import React, { useEffect, useState } from "react";
import { i18n, useTranslation } from "next-i18next";
import ICONS from "@config/icons";
import {
  IMG_EKOSISTEM_KUAT,
  IMG_KEMUDAHAN_PEMANTAUAN,
  IMG_PENGALAMAN,
  IMG_SOLUSI_KOMPREHENSIF,
} from "@config/images";
import { useGetInsightQuery } from "@libraries/repositories/insight/insight.redux";
import { LANDING_PAGE_API } from "@libraries/repositories/landing-page/landingpage.hooks";

const useAction = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [testimony, setTestimony] = useState<any>([]);
  const [value, setValue] = useState("ringkasan");
  const { t } = useTranslation("common");
  const lang = i18n?.language;

  const getTestimony = async () => {
    try {
      const { data } = await LANDING_PAGE_API.GET_TESTIMONY();
      setTestimony(data);
    } catch {
      setTestimony({});
    }
  };

  const params = "Success Story";

  const { data: insightList } = useGetInsightQuery({
    category: params, lang
  });

  const handleTabWhenScroll = (event: Event) => {
    const currentPosition = (event.target as Element).scrollTop;

    // array section for id section & value tab
    const sections = [
      { id: "section-summary", value: "summary" },
      { id: "section-uvp", value: "uvp" },
      { id: "section-testimony", value: "testimony" },
      { id: "section-success-story", value: "successStory" },
      { id: "section-contactus", value: "contact" },
    ];

    sections.forEach((section) => {
      const element = document.getElementById(section.id);
      if (element) {
        const min = element?.offsetTop - 150;
        const max = element?.offsetTop + element?.offsetHeight - 150;
        if (min < currentPosition && max > currentPosition) {
          setValue(section.value);
        }
      }
    });

    if (currentPosition < 500) {
      setIsVisible(false);
    } else {
      setIsVisible(true);
    }
  };

  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);

    const tabs = [
      { id: "#section-summary", value: "summary" },
      { id: "#section-uvp", value: "uvp" },
      { id: "#section-testimony", value: "testimony" },
      { id: "#section-success-story", value: "successStory" },
      { id: "#section-contactus", value: "contact" },
    ];

    tabs.forEach((tab) => {
      if (newValue === tab.value) {
        document.querySelector(tab.id)?.scrollIntoView({
          behavior: "auto",
          block: "start",
        });
      }
    });
  };

  const corporateReview = [
    {
      title: t("testimoni.review.0.title"),
      image: ICONS.ICON_BUILDING,
      point: "250+",
    },
    {
      title: t("testimoni.review.1.title"),
      image: ICONS.ICON_GOV_BUILDING,
      point: "350+",
    },
    {
      title: t("testimoni.review.2.title"),
      image: ICONS.ICON_BUSINESS,
      point: "1.540+",
    },
  ];

  const dataAbout = [
    {
      title: t("about.uvp.1.title"),
      description: t("about.uvp.1.desc"),
      image: IMG_SOLUSI_KOMPREHENSIF,
    },
    {
      title: t("about.uvp.2.title"),
      description: t("about.uvp.2.desc"),
      image: IMG_PENGALAMAN,
    },
    {
      title: t("about.uvp.3.title"),
      description: t("about.uvp.3.desc"),
      image: IMG_KEMUDAHAN_PEMANTAUAN,
    },
    {
      title: t("about.uvp.4.title"),
      description: t("about.uvp.4.desc"),
      image: IMG_EKOSISTEM_KUAT,
    },
  ];

  useEffect(() => {
    getTestimony();
  }, []);

  useEffect(() => {
    document.getElementById("about-page")?.addEventListener("scroll", handleTabWhenScroll);
    return () => {
      document.getElementById("about-page")?.removeEventListener("scroll", handleTabWhenScroll);
    };
  }, []);

  return {
    isVisible,
    insightList,
    testimony,
    valueTab: value,
    handleChangeTab,
    corporateReview,
    dataAbout,
  };
};

export default useAction;
